var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 87,
    viewBox: "0 0 95 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4612 86.9998C76.5969 79.9696 63.0856 75.6196 48.1683 75.6196C33.273 75.6196 19.7618 79.9696 9.89746 86.9998H86.4612Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7451 82.934C88.7898 83.1976 62.734 82.934 62.734 82.934L62.1189 80.2098L59.7461 69.4887C59.7461 69.4887 69.3468 69.972 68.7536 69.247C68.1605 68.544 67.1059 57.5153 61.7673 55.8456C56.4287 54.1759 48.1682 53.9343 48.1682 53.9343V32.9753L55.7916 27.8564C59.4825 32.1625 79.1672 43.1253 81.5619 48.376C83.9565 53.6047 93.3595 66.9402 94.2163 72.1689C95.0951 77.4196 92.7004 82.6923 90.7451 82.934Z",
    fill: "url(#paint0_linear_3307_569)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M90.7449 82.9345C88.7896 83.1981 62.7338 82.9345 62.7338 82.9345L62.1187 80.2103C66.9519 80.0126 74.0261 79.6391 80.5291 79.0898C91.8214 78.1232 94.2161 72.1694 94.2161 72.1694C95.0949 77.4201 92.7002 82.6928 90.7449 82.9345Z",
    fill: "url(#paint1_linear_3307_569)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.4612 69.8639C86.4612 69.8639 80.5734 57.0557 74.5977 53.7822L76.487 68.5018L86.4612 69.8639Z",
    fill: "url(#paint2_linear_3307_569)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.597 71.1145C74.597 71.1145 82.8356 68.5661 90.2832 72.2569C90.2832 72.2569 88.3939 68.5221 80.4629 66.8964C80.4629 66.8964 75.4099 50.2655 69.4342 49.4965C63.4585 48.7056 63.1509 72.2569 63.1509 72.2569L74.597 71.1145Z",
    fill: "#00042D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6118 27.8564C34.9209 32.1625 15.2362 43.1253 12.8416 48.376C10.4469 53.6047 1.04394 66.9402 0.187131 72.1689C-0.691649 77.4196 1.70302 82.6923 3.65831 82.934C5.6136 83.1976 31.6694 82.934 31.6694 82.934L34.6573 69.4887C34.6573 69.4887 25.0566 69.972 25.6498 69.247C26.243 68.544 27.2975 57.5153 32.6361 55.8456C37.9747 54.1759 46.2352 53.9343 46.2352 53.9343V32.9753L38.6118 27.8564Z",
    fill: "url(#paint3_linear_3307_569)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.65831 82.9345C5.6136 83.1981 31.6694 82.9345 31.6694 82.9345L32.2846 80.2103C27.4513 80.0126 20.3771 79.6391 13.8741 79.0898C2.5818 78.1232 0.187131 72.1694 0.187131 72.1694C-0.691649 77.4201 1.70302 82.6928 3.65831 82.9345Z",
    fill: "url(#paint4_linear_3307_569)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M7.94165 69.8639C7.94165 69.8639 13.8295 57.0557 19.8052 53.7822L17.9158 68.5018L7.94165 69.8639Z",
    fill: "url(#paint5_linear_3307_569)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5082 71.1145C20.5082 71.1145 12.2697 68.5661 4.82202 72.2569C4.82202 72.2569 6.7114 68.5221 14.6204 66.8964C14.6204 66.8964 19.6734 50.2655 25.6711 49.4965C31.6468 48.7056 31.9324 72.2569 31.9324 72.2569L20.5082 71.1145Z",
    fill: "#00042D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9961 27.0671C66.7105 33.2844 65.634 46.4002 61.2621 49.9593C57.9887 52.6176 52.0569 50.9479 47.619 50.9479C42.4342 50.9479 37.1835 53.4524 33.7123 49.9593C30.1972 46.4442 28.4836 32.5155 28.2419 27.0671C31.6472 19.7732 39.0509 14.6982 47.619 14.6982C56.2091 14.6982 63.6128 19.7732 66.9961 27.0671Z",
    fill: "url(#paint6_linear_3307_569)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.0996 20.8925C29.0996 30.0318 31.4284 39.6105 33.2518 43.8506C35.0973 48.0907 41.2048 55.802 47.6419 56.9444C54.0789 58.0868 60.3842 48.7498 62.4054 43.2135C65.7008 34.2939 66.0084 19.6622 66.0084 19.6622C66.0084 19.6622 55.507 10.1054 45.6866 11.0062C35.8882 11.885 29.0996 20.8925 29.0996 20.8925Z",
    fill: "url(#paint7_linear_3307_569)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0754 18.6531C33.0754 25.7273 34.8989 33.131 36.3489 36.4045C37.7769 39.6999 41.8193 46.5544 47.6192 46.5544C52.7381 46.5544 57.6154 40.2052 59.1972 35.9431C61.7896 29.0228 62.0312 17.6865 62.0312 17.6865C62.0312 17.6865 53.7927 10.3047 46.1034 10.9858C38.3921 11.6668 33.0754 18.6531 33.0754 18.6531Z",
    fill: "#00042D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6195 0C40.4794 0 28.2205 14.7635 28.2205 26.0778C28.2205 26.4147 28.2278 26.7442 28.2424 27.0664C31.6477 19.7726 39.0514 14.6976 47.6195 14.6976C56.2096 14.6976 63.6133 19.7726 66.9966 27.0664C67.0113 26.7442 67.0186 26.4147 67.0186 26.0778C67.0186 14.7635 55.0013 0 47.6195 0Z",
    fill: "url(#paint8_linear_3307_569)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9296 81.7479H24.3103C22.1134 81.7479 20.2679 80.0562 20.0922 77.8592L17.4558 47.5633C17.2361 45.0807 19.1914 42.9497 21.674 42.9497H73.5659C76.0705 42.9497 78.0038 45.0807 77.8061 47.5633L75.1697 77.8592C74.972 80.0562 73.1485 81.7479 70.9296 81.7479Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9296 83.0662H24.3103C22.1134 83.0662 20.2679 81.3746 20.0922 79.1776L17.4558 48.8817C17.2361 46.3991 19.1914 44.2681 21.674 44.2681H73.5659C76.0705 44.2681 78.0038 46.3991 77.8061 48.8817L75.1697 79.1776C74.972 81.3746 73.1485 83.0662 70.9296 83.0662Z",
    fill: "url(#paint9_linear_3307_569)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2444 44.2681H21.674C19.1914 44.2681 17.2361 46.3991 17.4558 48.8817L20.0922 79.1776C20.2679 81.3746 22.1134 83.0662 24.3103 83.0662H26.1338L24.2444 44.2681Z",
    fill: "url(#paint10_linear_3307_569)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5653 44.2681H70.9948L69.1055 83.0662H70.9289C73.1479 83.0662 74.9713 81.3746 75.169 79.1776L77.8054 48.8817C78.0031 46.3991 76.0698 44.2681 73.5653 44.2681Z",
    fill: "url(#paint11_linear_3307_569)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3307_569",
    x1: 7.54111,
    y1: 84.7043,
    x2: 66.9595,
    y2: -24.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AC24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3307_569",
    x1: 69.8756,
    y1: 86.5852,
    x2: 79.9845,
    y2: 64.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D63B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3307_569",
    x1: 94.7393,
    y1: 50.4317,
    x2: 90.8769,
    y2: 73.0543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D63B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3307_569",
    x1: -23.0239,
    y1: 52.1989,
    x2: 18.1071,
    y2: -23.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AC24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3307_569",
    x1: 24.5276,
    y1: 86.5852,
    x2: 14.4188,
    y2: 64.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D63B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3307_569",
    x1: -0.336458,
    y1: 50.4317,
    x2: 3.52598,
    y2: 73.0543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D63B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3307_569",
    x1: -3.03296,
    y1: 75.3936,
    x2: 44.9419,
    y2: -13.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AC24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3307_569",
    x1: 14.2001,
    y1: 55.264,
    x2: 18.5475,
    y2: 13.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D63B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3307_569",
    x1: -2.75325,
    y1: 75.5087,
    x2: 44.6073,
    y2: -11.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AC24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3307_569",
    x1: 75.3272,
    y1: 43.7404,
    x2: 52.2382,
    y2: 103.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A76DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3307_569",
    x1: 109.753,
    y1: 48.2993,
    x2: 108.016,
    y2: 85.0773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3307_569",
    x1: 161.315,
    y1: 50.6403,
    x2: 159.587,
    y2: 87.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C1CB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.7312bff788c86856543da25e7bb96d5f.svg";
export { ForwardRef as ReactComponent };